import { render, staticRenderFns } from "./StatisticCardWithLineChart.vue?vue&type=template&id=632c0ec7&"
import script from "./StatisticCardWithLineChart.vue?vue&type=script&lang=js&"
export * from "./StatisticCardWithLineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports